import { match } from "ts-pattern";

import logo from "~/assets/logo.svg?url";
import { categories } from "~/utils/category";

import { type PackCategory } from "./PackCategory";

export const PackCategoryLabel: React.FC<{
  category?: PackCategory;
}> = ({ category }) => {
  if (!category) {
    return <>All categories</>;
  }

  return match(category)
    .with("original", () => (
      <>
        <img src={logo} alt="Knoword logo" className="-mx-px size-5" />
        Made by Knoword
      </>
    ))
    .with("staff-pick", () => (
      <>
        <span>🏅</span>
        Staff Picks
      </>
    ))
    .otherwise((category) => {
      const { name, emoji } = categories[category];
      return (
        <>
          <span>{emoji}</span>
          <span className="whitespace-nowrap">{name}</span>
        </>
      );
    });
};
